export default "/fonts/vendor/mdui/dist/roboto/Roboto-MediumItalic.woff2?113e7623163d4cb7f965cd8f8d3859eb";